"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullConsoleLog = fullConsoleLog;
exports.toString = toString;
const util = require("util");
function fullConsoleLog(object) {
    console.log(util.inspect(object, { showHidden: false, depth: null, colors: true }));
}
function toString(object) {
    return util.inspect(object, { showHidden: false, depth: 20, colors: false });
}
//# sourceMappingURL=full-console-log.js.map